// Re-export directo desde el componente real (no via catalog/public-api) para
// evitar require cycle: catalog/public-api -> ... -> inventory/public-api ->
// este shim -> catalog/public-api (sin inicializar) -> crash en runtime.
export { BulkCoefficientModal } from '../../catalog/components/BulkCoefficientModal';

